import type { LanguageResource } from "@ruter-as/web-components-and-tools";

interface ErrorLanguageResource {
	genericError: {
		title: string;
	};
	initError: {
		title: string;
		reason: string;
		missingUserName: string;
		missingKey: string;
		serverError: string;
		incompleteUsblParams: string;
	};
}

const errorLanguageResource: LanguageResource<ErrorLanguageResource> = {
	nb: {
		genericError: {
			title: "Det har skjedd en feil!",
		},
		initError: {
			title: "Klarte ikke laste widget.",
			reason: "Årsak",
			missingUserName: "Mangler 'id'",
			missingKey: "Mangler 'secret'",
			serverError: "Klarte ikke logge inn",
			incompleteUsblParams: "Ufullstendige parametere for direkteinnlogging",
		},
	},
};

export default errorLanguageResource;
